import { ArrowDownTrayIcon, ArrowPathIcon, TrashIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface SelectionBarProps {
    selectedCount: number;
    onSelectAll: () => void;
    onClearSelection: () => void;
    onDownloadSelected: () => void;
    /** Omit to hide the delete action entirely (capability-gated by the host). */
    onDeleteSelected?: () => void;
    isDownloading: boolean;
    isDeleting: boolean;
    hasGcsSelected: boolean;
}

const SelectionBar: React.FC<SelectionBarProps> = ({
    selectedCount,
    onSelectAll,
    onClearSelection,
    onDownloadSelected,
    onDeleteSelected,
    isDownloading,
    isDeleting,
    hasGcsSelected
}) => (
    <div className="flex flex-wrap items-center gap-2 bg-gray-50 rounded-lg px-4 py-2.5 border border-gray-200">
        <div className="flex items-center gap-3 min-w-0">
            <span className="text-xs text-gray-600 font-medium whitespace-nowrap">
                {selectedCount} {selectedCount === 1 ? 'file' : 'files'} selected
            </span>
            <button
                onClick={onSelectAll}
                className="text-xs text-gray-900 font-medium hover:underline whitespace-nowrap"
            >
                Select all
            </button>
            {selectedCount > 0 && (
                <button
                    onClick={onClearSelection}
                    className="text-xs text-gray-500 hover:text-gray-700 hover:underline whitespace-nowrap"
                >
                    Clear
                </button>
            )}
        </div>
        <div className="flex flex-wrap items-center gap-2 ml-auto">
            {hasGcsSelected && onDeleteSelected && (
                <button
                    onClick={onDeleteSelected}
                    disabled={selectedCount === 0 || isDeleting}
                    className="inline-flex items-center gap-2 bg-red-600 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                    {isDeleting ? (
                        <>
                            <ArrowPathIcon className="w-3.5 h-3.5 animate-spin" />
                            Deleting...
                        </>
                    ) : (
                        <>
                            <TrashIcon className="w-3.5 h-3.5" />
                            Delete
                        </>
                    )}
                </button>
            )}
            <button
                onClick={onDownloadSelected}
                disabled={selectedCount === 0 || isDownloading}
                className="inline-flex items-center gap-2 bg-gray-900 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
                {isDownloading ? (
                    <>
                        <ArrowPathIcon className="w-3.5 h-3.5 animate-spin" />
                        Downloading...
                    </>
                ) : (
                    <>
                        <ArrowDownTrayIcon className="w-3.5 h-3.5" />
                        Download
                    </>
                )}
            </button>
        </div>
    </div>
);

export { SelectionBar };
